import {atom, selectorFamily, useSetRecoilState} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {serialize} from '../../../shared/utils/serialize-query-params';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getContracts} = api.contracts;

const getContractsRefresh = atom<number>({
  key: 'getContractsRefresh',
  default: 0,
});

const getContractsQuery = selectorFamily({
  key: 'getContracts',
  get(params: Parameters<typeof getContracts>[0]) {
    return async ({get}) => {
      get(getContractsRefresh);
      try {
        const {data} = await getContracts(params, {paramsSerializer: {serialize}});
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetContractsQueryRefresh = () => {
  const refreshFn = useSetRecoilState(getContractsRefresh);
  return () => refreshFn((prev) => prev + 1);
};

export const useGetContractsQuery = createQuery(getContractsQuery, getContractsRefresh);

export type GetContractsQueryParams = Parameters<typeof getContractsQuery>[0];
